import Vue from 'vue'

const state = {
    stop: {
        '1.0': 'teacher',
        '1.1': 'student',
        '1.2': 'all',
        map: {
            'teacher/teacher': ['clearCurrentChecked', 'addDesabledOfAll', 'addDesabledOfTeacher', 'addStudent'],
            'teacher/all': ['clearCurrentChecked', 'addDesabledOfAll', 'addDesabledOfTeacher', 'addStudent'],
            'teacher/set': ['clearCurrentChecked', 'addDesabledOfAll', 'addDesabledOfTeacher', 'addStudent'],
            'student/student': ['clearCurrentChecked', 'addDesabledOfAll', 'addDesabledOfStudent', 'addTeacher'],
            'student/teacher': [],
            'teacher/student': [],
            'student/all': ['clearCurrentChecked', 'addDesabledOfAll', 'addDesabledOfStudent', 'addTeacher'],
            'student/set': ['clearCurrentChecked', 'addDesabledOfAll', 'addDesabledOfStudent', 'addTeacher'],
            'all/all': ['clearCurrentChecked', 'addDesabledOfAll', 'addDesabledOfStudent', 'addDesabledOfTeacher'],
            'all/teacher': ['clearCurrentChecked', 'addDesabledOfAll', 'addDesabledOfStudent', 'addDesabledOfTeacher'],
            'all/student': ['clearCurrentChecked', 'addDesabledOfAll', 'addDesabledOfStudent', 'addDesabledOfTeacher'],
            'all/set': ['clearCurrentChecked', 'addDesabledOfAll', 'addDesabledOfStudent', 'addDesabledOfTeacher'],
        }
    },
    play: {
        1: 'all',
        2: 'teacher',
        3: 'student',
        4: 'set',
        map: {
            'all/all': ['clearValOfStopCodeList', 'clearOfStopCode', 'clearOfStopCodeCurrent'],
            'all/teacher': ['clearValOfStopCodeList', 'clearOfStopCode', 'clearOfStopCodeCurrent'],
            'all/student': ['clearValOfStopCodeList', 'clearOfStopCode', 'clearOfStopCodeCurrent'],
            'set/teacher': ['clearValOfStopCodeList', 'clearOfStopCode', 'clearOfStopCodeCurrent'],
            'set/student': ['clearValOfStopCodeList', 'clearOfStopCode', 'clearOfStopCodeCurrent'],
            'set/all': ['clearValOfStopCodeList', 'clearOfStopCode', 'clearOfStopCodeCurrent'],
            'teacher/teacher': ['clearValOfStopCodeList', 'clearOfStopCode', 'clearOfStopCodeCurrent'],
            'teacher/student': [],
            'student/teacher': [],
            'teacher/all': ['clearValOfStopCodeList', 'clearOfStopCode', 'clearOfStopCodeCurrent'],
            'student/all': ['clearValOfStopCodeList', 'clearOfStopCode', 'clearOfStopCodeCurrent'],
            'student/student': ['clearValOfStopCodeList', 'clearOfStopCode', 'clearOfStopCodeCurrent'],
        }
    },
    stopValue: '',
    playValue: 1,
    mapping: {
        voice: {
            stop: {
                '0.0': 'host',
                '0.1': 'student',
                '0.2': 'all',
                '': false
            }
        },
        receive: {
            stop: {
                '1.0': 'host',
                '1.1': 'student',
                '1.2': 'all',
                '': false
            },
            play: {
                1: 'all',
                2: 'host',
                3: 'student',
                4: 'set',
            }
        }
    }
}

export const store = Vue.observable(state)

export const mutations = {
    playValue (payload) {
        Object.assign(store, { playValue: payload })
    },
    stopValue (payload) {
        Object.assign(store, { stopValue: payload })
    },
    stopVoiceValue (payload) {
        Object.assign(store, { stopVoiceValue: payload })
    }
}
